import React from 'react';
import { observer, inject } from 'mobx-react';
import {
  Grid,
  TextField,
  Paper,
  withStyles,
  Button,
  // FormHelperText
} from '@material-ui/core';
import PageTitle from '../../components/PageTitle/PageTitle';
import FormInputLabel from '../../components/FormInputLabelView';
// import Swal from 'sweetalert2';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
// import { clearLocalStorage } from '../../utils/common'

class DevicePermissionPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this); // i think you are missing this
    // this.initData = this.initData;
    this.state = {
      data: {
        id: '',
        name: '',
        manufacturer: '',
        description: '',
        contactPerson: '',
        address: '',
        tel: '',
        email: '',
        imgUrl: '',
      },
      checked: false,
      errorField: {
        name: false,
        manufacturer: false,
      },
      isLoading: false,
    };
  }
  async componentDidMount() {
    this.initData();
  }

  //   createDeviceType = async () => {
  //     const { t } = this.props;
  //     let { data } = this.state;
  //     try {
  //       const result = await this.props.deviceType.createDeviceType(data);
  //       if (result.statusCode === 200) {
  //         Swal.fire({ html: `<h4>${t('create_success')}`, type: "success" }).then(async resultSuccess => {
  //           if (resultSuccess.value) {
  //             this.props.history.push('../devicetype')
  //           } else {
  //             Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: "error" });
  //           }
  //         });
  //       }
  //     } catch (e) {
  //       if (e.statusCode === 401) {
  //         clearLocalStorage();
  //         window.location.href = '/login'
  //       } else if (e.statusCode === 400) {
  //         const msg = e.error.message || `${t('failed_to_create')}`;
  //         Swal.fire({ html: `<h4>${msg}`, type: "error" });
  //       } else {
  //         Swal.fire({ html: `<h4>${t('failed_to_create')}`, type: "error" });
  //       }
  //     }
  //   }

  goBack() {
    this.props.history.goBack();
  }

  initData() {
    // const { groups } = this.props.group.toJS();
    // const deviceType = this.props.deviceType.toJS()
    // const serialPath = this.props.location.pathname.replace('/app/devicetype/', '')
    // const id = Number(serialPath.replace('/edit', ''))
    // const showDeviceData = deviceType.deviceTypes.find(item => item.id === id)
    const showDeviceData = '';
    if (showDeviceData) {
      this.setState({
        data: {
          id: showDeviceData.id,
          name: showDeviceData.name,
          manufacturer: showDeviceData.manufacturer,
          description: showDeviceData.description,
          contactPerson: showDeviceData.contactPerson,
          // contractPerson: showDeviceData.contactPerson,
          address: showDeviceData.address,
          tel: showDeviceData.tel,
          email: showDeviceData.email,
          imgUrl: showDeviceData.imgUrl,
        },
      });
    }
  }
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
  };
  validate() {
    const { data } = this.state;
    if (!data.name || !data.manufacturer) {
      let checkName = !data.name ? true : false;
      let checkManufacturer = !data.manufacturer ? true : false;
      this.setState({
        errorField: {
          name: checkName,
          manufacturer: checkManufacturer,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          name: false,
          manufacturer: false,
        },
      });
    }
    return true;
  }
  clearErrorField(key) {
    if (key === 'name') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          name: false,
        },
      });
    }
    if (key === 'manufacturer') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          manufacturer: false,
        },
      });
    }
  }
  handleCreateDevice() {
    if (this.validate()) {
      if (this.dropZoneDeviceType && this.dropZoneDeviceType.state.files.length > 0) {
        this.onUploadDeviceType();
      } else {
        this.createDeviceType();
      }
    }
  }

  handleEditDevice() {
    if (this.validate()) {
      if (this.dropZoneDeviceType && this.dropZoneDeviceType.state.files.length > 0) {
        this.onUploadDeviceType();
      } else {
        this.updateDeviceType('update');
      }
    }
  }
  render() {
    const { classes, t } = this.props;
    const { data } = this.state;

    return (
      <React.Fragment>
        <Loader loading={data.isLoading} />
        <PageTitle title={t('manage_device_permission')} />
        <Paper className={classes.paper}>
          <Grid container>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('description')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='description'
                name='description'
                fullWidth
                value={data.description}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('contact_person')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='contactPerson'
                name='contactPerson'
                fullWidth
                value={data.contactPerson}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('address')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='address'
                name='address'
                fullWidth
                value={data.address}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('tel')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='tel'
                name='tel'
                fullWidth
                value={data.tel}
                onChange={this.handleChange}
                inputProps={{ maxLength: 10 }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, '');
                }}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('email')} />
            </Grid>
            <Grid item xs={12} sm={10}>
              <TextField
                id='email'
                name='email'
                fullWidth
                value={data.email}
                onChange={this.handleChange}
                variant='outlined'
                margin='dense'
              />
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => this.handleCreateDevice()}
                  className={classes.button}
                >
                  {t('create')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
  //   render() {
  //     const path = this.props.match.path.replace('/app/devicetype/:id/', '')
  //     let result
  //     switch (path) {
  //       case 'edit':
  //         result = this.renderFormEdit()
  //         break;
  //       case 'view':
  //         result = this.renderView()
  //         break;
  //       default:
  //         result = this.renderFormCreate()
  //         break;
  //     }
  //     return result
  //   }
}

const styles = (theme) => ({
  paper: {
    padding: '50px',
    marginTop: '-100px',
    height: '100%',
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing.unit * 3,
    marginLeft: theme.spacing.unit * 1,
  },
  formControl: {
    width: '100%',
  },
  title: {
    textTransform: 'capitalize',
  },
});
export const page = inject('device', 'subGroup', 'group')(observer(DevicePermissionPage));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
